import { useEffect, useState } from 'react'
import { toast } from 'react-hot-toast'
import { RefreshCw } from 'lucide-react'
import { debug } from '../../lib/utils/debug'

export function ServiceWorkerUpdate() {
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null)
  const [updateAvailable, setUpdateAvailable] = useState(false)

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((reg) => {
        setRegistration(reg)

        // Check for updates
        reg.update()

        // Listen for new service worker
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New service worker available
                setUpdateAvailable(true)
                showUpdateToast()
              }
            })
          }
        })
      })

      // Listen for controller change (service worker activated)
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        debug.log('Service worker controller changed - reloading page')
        window.location.reload()
      })
    }
  }, [])

  const showUpdateToast = () => {
    toast(
      (t) => (
        <div className="flex items-center gap-3">
          <div className="flex-1">
            <p className="font-semibold text-sm">Update Available</p>
            <p className="text-xs text-gray-600 dark:text-gray-400">
              A new version of the app is ready
            </p>
          </div>
          <button
            onClick={() => {
              updateServiceWorker()
              toast.dismiss(t.id)
            }}
            className="px-4 py-2 bg-salt-gold text-salt-navy rounded-lg text-sm font-semibold hover:bg-salt-gold-dark transition-colors flex items-center gap-2"
          >
            <RefreshCw className="w-4 h-4" />
            Update
          </button>
        </div>
      ),
      {
        duration: Infinity, // Don't auto-dismiss
        id: 'sw-update', // Use same ID to prevent duplicates
        position: 'bottom-right',
      }
    )
  }

  const updateServiceWorker = () => {
    if (registration?.waiting) {
      // Tell the waiting service worker to skip waiting and become active
      registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    } else {
      // Force reload if no waiting worker
      window.location.reload()
    }
  }

  return null // This component doesn't render anything
}

